import React, { useEffect } from "react";
import { Fragment } from "react";
import HeaderHome from "../layout/HeaderHome";
import childre from "../static/images/Nuevo-Logo-ChildrenBelieve.png";
import FooterHome from "../layout/FooterHome";

function Nosotros() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <Fragment>
      <HeaderHome></HeaderHome>
      <section id="hero" className="nosotros">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 px-0">
              <div className="nosotros__wrapper nosotros__js">
                <div className="nosotros__item">
                  <div className="nosotros__itemWrapper">
                    <div className="nosotros__center">
                      <div className="nosotros__title">
                        Somos Children Believe
                      </div>
                      <div className="nosotros__content">
                        <p>
                          Empoderamiento económico, inclusión, innovación y un
                          futuro con mejores oportunidades de crecimiento.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="nuestros-socios" id="sectionsocio">
        <div className="container" id="sectionsocio">
          <div className="row">
            <div className="col-lg-12 nuestros-socios-content">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-3  left-side">
                  <img
                    src={childre}
                    style={{ height: "100%", width: "100%" }}
                  ></img>
                </div>
                <div className="col-md-7 right-side">
                  <h4>Children Believe</h4>
                  <p>
                    Children Believe es la organización que lidera el proyecto
                    EMPUJE en Nicaragua, Durante 60 años, hemos reunido a
                    jóvenes soñadores , simpatizantes, socios e idealistas.
                    Juntos, nos impulsa una creencia común: crear acceso a la
                    educación, dentro y fuera de las aulas. La educación es la
                    herramienta más poderosa que la niñez pueden usar para
                    cambiar su mundo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterHome></FooterHome>
    </Fragment>
  );
}

export default Nosotros;
